import React from "react";
import { MessageCircle } from "lucide-react";

import { Button } from "./ui/button";

export default function FloatingActionButtonSize() {
  return (
    <a
      href="https://wa.me/5548996523066"
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-4 z-30"
    >
      <Button
        size="lg"
        className="rounded-full bg-emerald-500 shadow-2xl transition hover:bg-emerald-400"
      >
        <MessageCircle className="mr-2 h-5 w-5" /> WhatsApp
      </Button>
    </a>
  );
}
